module.exports = __webpack_public_path__ + "img/2_225.8901e1c3.png";